import { setAllPosts } from "features/allPosts/allPostsSlice";
import { usersList } from "features/allUsers/usersSlice";
import { circlesList, setAllCircles } from "features/allCircle/circleSlice";
import { setAllFeed } from "features/allFeed/allFeedSlice";
import { recommendationList } from "features/allRecommendations/recommedationSlice";

import {
  addBookmark,
  login,
  logout,
  setArchive,
  setFollowing,
} from "features/user/userSlice";
import { onAuthStateChanged } from "firebase/auth";
import {
  collection,
  doc,
  onSnapshot,
  orderBy,
  query,
} from "firebase/firestore";
import toast from "react-hot-toast";
import { auth, db } from "./firebase";

export const firebaseListeners = (dispatch) => {
  authChangeListener(dispatch);
  postsListener(dispatch);
  usersListener(dispatch);
  circleListener(dispatch);
};

const authChangeListener = (dispatch) => {
  try {
    onAuthStateChanged(auth, (userAuth) => {
      if (userAuth) {
        dispatch(
          login({
            email: userAuth.email,
            uid: userAuth.uid,
            displayName: userAuth.displayName,
            photoURL: userAuth.photoURL,
          })
        );
      } else {
        dispatch(logout());
      }
    });
  } catch (error) {
    console.error(error.message);
  }
};

const usersListener = (dispatch) => {
  try {
    onSnapshot(collection(db, "users"), (snapshot) => {
      const allUsersList = snapshot.docs.map((doc) => doc.data());
      dispatch(usersList(allUsersList));
    });
  } catch (error) {
    console.error(error.message);
  }
};

const recommendationListener = (dispatch) => {
  try {
    onSnapshot(collection(db, "recommendation"), (snapshot) => {
      const allRecommendationList = snapshot.docs.map((doc) => doc.data());
      dispatch(recommendationList(allRecommendationList));
    });
  } catch (error) {
    console.error(error.message);
  }
};

const circleListener = (dispatch) => {
  console.log("circleListener");
  
  try {
    const loader = toast.loading("Loading..");
    const q = query(collection(db, "allCircles"));
    onSnapshot(q, (snapshot) => {
      const allCirclesList = snapshot.docs.map((doc) => doc.data());
      dispatch(setAllCircles(allCirclesList));
    });
    toast.dismiss(loader);
    console.log("Circle Fetched");
  } catch (error) {
    console.error(error.message);
  }
};

const postsListener = (dispatch) => {
  try {
    const loader = toast.loading("Loading..");
    const q = query(collection(db, "allPosts"), orderBy("createdAt", "desc"));
    onSnapshot(q, (snapshot) => {
      const allPostsList = snapshot.docs.map((doc) => doc.data());
      dispatch(setAllPosts(allPostsList));
    });
    toast.dismiss(loader);
    console.log("Post Fetched");
  } catch (error) {
    console.error(error.message);
  }
};
const feedListener = (dispatch) => {
  try {
    const loader = toast.loading("Loading..");
    const q = query(collection(db, "allFeed"), orderBy("createdAt", "desc"));
    onSnapshot(q, (snapshot) => {
      const allFeedList = snapshot.docs.map((doc) => doc.data());
      dispatch(setAllFeed(allFeedList));
    });
    toast.dismiss(loader);
    console.log("Feed Fetched");
  } catch (error) {
    console.error(error.message);
  }
};

const followingListener = (dispatch, userID) => {
  try {
    onSnapshot(doc(db, "users", userID), (doc) => {
      const following = doc.data().following;
      dispatch(setFollowing(following));
    });
  } catch (error) {
    console.error(error.message);
  }
};

const archivesListener = (dispatch, userID) => {
  try {
    onSnapshot(doc(db, "users", userID), (doc) => {
      const archives = doc.data().archives;
      dispatch(setArchive(archives));
    });
  } catch (error) {
    console.error(error.message);
  }
};

const bookmarksListener = (dispatch, userID) => {
  try {
    onSnapshot(doc(db, "users", userID), (doc) => {
      const bookmarks = doc.data().bookmarks;
      dispatch(addBookmark(bookmarks));
    });
  } catch (error) {
    console.error(error.message);
  }
};

export const userDataListeners = (dispatch, userID) => {
  followingListener(dispatch, userID);
  archivesListener(dispatch, userID);
  bookmarksListener(dispatch, userID);
  feedListener(dispatch, userID)
  recommendationList(dispatch, userID)
};
